import { W, H, R } from "./props";

export const QUAKE_DURATION = 15;
const Q_CAPTIONS = [
  [0.6, 3.6, "The world goes dark and quiet."],
  [4.4, 7.4, "Then the ground ROARS."],
  [7.8, 11.0, "The ridge shakes. Snow pours off the trees."],
  [11.6, 14.6, "Joe wakes face-down in the snow. It's night."],
];
export const quakeCaption = (tt) => (Q_CAPTIONS.find(([a, b]) => tt >= a && tt <= b) || [])[2] || null;
const G = 146;

export function drawQuake(ctx, tt, now) {
  R(ctx, "#000", 0, 0, W, H);
  if (tt < 4.2) return;
  const shaking = tt < 11.2, amp = shaking ? 4 * Math.min(1, (tt - 4.2) * 1.5) : 0;
  const ox = Math.round((Math.random() - 0.5) * amp * 2), oy = Math.round((Math.random() - 0.5) * amp);
  ctx.save(); ctx.translate(ox, oy);
  ["#03050b", "#050914", "#070d1a"].forEach((c, i) => R(ctx, c, -8, i * 50, W + 16, 50));
  for (let s = 0; s < 120; s++) R(ctx, "#0a1222", s * 3 - 8, 70 + Math.abs(((s * 2.6) % 70) - 35), 3, H);
  for (let x = -4, i = 0; x < W + 8; x += 22 + (i % 3) * 6, i++) {
    const sway = shaking ? Math.round(Math.sin(now / 60 + i) * 2) : 0;
    R(ctx, "#05080f", x + 4, G - 14, 3, 14);
    for (let k = 0; k < 5; k++) R(ctx, "#070c16", x + 5 - (2 + k * 3) + sway, G - 52 + k * 8, 4 + k * 6, 9);
    R(ctx, "#c8d6e3", x + 3 + sway, G - 52, 4, 1);
  }
  R(ctx, "#a9bccd", -8, G, W + 16, H - G); R(ctx, "#7e93a8", -8, G, W + 16, 1);
  R(ctx, "#2a1a10", 120, G - 6, 60, 6); R(ctx, "#3a2414", 120, G - 7, 60, 1);
  if (shaking) for (let i = 0; i < 40; i++) R(ctx, "#dbe6f0", (i * 37 + now * 0.05) % W, ((i * 53 + now * 0.18 * (1 + (i % 3))) % (G - 10)), 2 + (i % 3), 2);
  const up = tt > 13 ? Math.min(1, (tt - 13) / 1.2) : 0;
  if (up < 0.5) { R(ctx, "#3d5a3d", 140, G - 4, 14, 4); R(ctx, "#d9b48f", 154, G - 4, 4, 4); }
  else { R(ctx, "#1f2430", 150, G - 7, 3, 7); R(ctx, "#1f2430", 154, G - 7, 3, 7); R(ctx, "#3d5a3d", 149, G - 17, 9, 10); R(ctx, "#d9b48f", 150, G - 23, 7, 6); }
  R(ctx, "#7a6a4a", 132, G - 2, 6, 2);
  for (let i = 0; i < 70; i++) R(ctx, "#e8f1ff", (i * 73.13 + now * 0.01) % W, (i * 41.7 + now * 0.02) % H, 1, 1);
  ctx.restore();
  R(ctx, "#000", 0, 0, W, 16); R(ctx, "#000", 0, H - 16, W, 16);
  const fade = tt < 4.8 ? 1 - (tt - 4.2) / 0.6 : tt > QUAKE_DURATION - 1 ? tt - (QUAKE_DURATION - 1) : 0;
  if (fade > 0) { ctx.fillStyle = `rgba(0,0,0,${Math.min(1, fade)})`; ctx.fillRect(0, 0, W, H); }
}
